import request from '@/utils/request'
// getSummaryStatus
export function getSummaryStatus(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/getSummaryStatus`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
//drawCurDockEvent
export function getCurDockEvent(param) {
    let data = param
    return request({
      url: `/v20/getCurDockEvent`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}
//drawMovingSCH
export function getMoveSch(param) {
    let data = param
    return request({
      url: `/v20/getMoveSch`,
      method: 'POST',
      meta: { apiVersion: '1.0.0' },
      headers: { 'Content-Type': 'application/json;charset=utf8' },
      data
    })
}  
//drawBlkStock
export function getBlkStock(param) {
  let data = param
  return request({
    url: `/v20/getBlkStock`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  
//drawShipEvent
export function getShipEvent(param) {
  let data = param
  return request({
    url: `/v20/getShipEvent`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
}  

//drawLayUpInfo
export function getLayUpEvt(param) {
  let data = param
  return request({
    url: `/v20/getLayUpEvt`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//drawNixShipInfo
export function getNixShipList(param) {
  let data = param
  return request({
    url: `/v20/getNixShipList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

//drawMatShipInfo
export function getMatShipList(param) {
  let data = param
  return request({
    url: `/v20/getMatShipList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    data
  })
} 

// ShowHeaderInfo
export function getConfirmInfo(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/getConfirmInfo`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}
//drawAddObj
export function getAddObj(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/getAddObj`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

//ShowShip
export function getShipList(param) {
  let data = param
  // console.log('param', param)
  return request({
    url: `/v20/getShipList`,
    meta: { apiVersion: '1.0.0' },
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data
  })
}

 
